export default __webpack_public_path__ + "static/media/magod.0bbc29bd.webp";